<script>
import DataProvider from './DataProvider.vue';
import EmployeeRepository from '../../js/repository/EmployeeRepository';

export default {
    components: {
        'kgr-data-provider': DataProvider,
    },
    props: {
        employeeId: {
            type: Number,
            required: true,
        },
        callback: {
            type: Function,
            required: false,
        }
    },
    render(createElement) {
        return createElement(DataProvider, {
            props: {
                repository: EmployeeRepository.findSpokenLanguages,
                params: [this.employeeId],
                callback: this.callback,
            },
            scopedSlots: this.$scopedSlots,
        });
    }
}
</script>
